import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import StickyMobileCta from './components/StickyMobileCta';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import ProblemPage from './pages/ProblemPage';
import TherapyAndHypnosis from './pages/TherapyAndHypnosis';
import AboutKim from './pages/AboutKim';
import Pricing from './pages/Pricing';
import Supervision from './pages/Supervision';
import Coaching from './pages/Coaching';
import CorporatePsychotherapist from './pages/CorporatePsychotherapist';
import GroupSupervision from './pages/GroupSupervision';
import ConflictManagement from './pages/ConflictManagement';
import Workshops from './pages/Workshops';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ArticlesIndex from './pages/ArticlesIndex';
import ArticleDetail from './pages/ArticleDetail';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-[#ECEEF1] text-[#11161d] selection:bg-[#5A232E]/20 selection:text-[#5A232E]">
      {/* Scroll restoration */}
      <ScrollToTop />

      {/* Primary header */}
      <Header />

      {/* Main route view */}
      <main className="flex-grow">
        <Routes>
          {/* Forside */}
          <Route path="/" element={<Home />} />

          {/* De 7 dedikerede Google Ads / SEO problemsider */}
          <Route path="/stress/" element={<ProblemPage fixedSlug="stress" />} />
          <Route path="/stress" element={<ProblemPage fixedSlug="stress" />} />

          <Route path="/angst/" element={<ProblemPage fixedSlug="angst" />} />
          <Route path="/angst" element={<ProblemPage fixedSlug="angst" />} />

          <Route path="/depression/" element={<ProblemPage fixedSlug="depression" />} />
          <Route path="/depression" element={<ProblemPage fixedSlug="depression" />} />

          <Route path="/lavt-selvvaerd/" element={<ProblemPage fixedSlug="lavt-selvvaerd" />} />
          <Route path="/lavt-selvvaerd" element={<ProblemPage fixedSlug="lavt-selvvaerd" />} />

          <Route path="/traumer/" element={<ProblemPage fixedSlug="traumer" />} />
          <Route path="/traumer" element={<ProblemPage fixedSlug="traumer" />} />

          <Route path="/sorg-og-krise/" element={<ProblemPage fixedSlug="sorg-og-krise" />} />
          <Route path="/sorg-og-krise" element={<ProblemPage fixedSlug="sorg-og-krise" />} />

          <Route path="/hypnose-vaner/" element={<ProblemPage fixedSlug="hypnose-vaner" />} />
          <Route path="/hypnose-vaner" element={<ProblemPage fixedSlug="hypnose-vaner" />} />

          {/* Primære ydelser */}
          <Route path="/terapi-og-hypnose/" element={<TherapyAndHypnosis />} />
          <Route path="/terapi-og-hypnose" element={<TherapyAndHypnosis />} />
          <Route path="/hypnose/" element={<TherapyAndHypnosis />} />
          <Route path="/hypnose" element={<TherapyAndHypnosis />} />

          {/* Om Kim */}
          <Route path="/om-kim/" element={<AboutKim />} />
          <Route path="/om-kim" element={<AboutKim />} />

          {/* Priser */}
          <Route path="/priser/" element={<Pricing />} />
          <Route path="/priser" element={<Pricing />} />

          {/* Ydelser (tidl. Sekundære ydelser) */}
          <Route path="/supervision/" element={<Supervision />} />
          <Route path="/supervision" element={<Supervision />} />

          <Route path="/gruppesupervision/" element={<GroupSupervision />} />
          <Route path="/gruppesupervision" element={<GroupSupervision />} />

          <Route path="/konflikthaandtering/" element={<ConflictManagement />} />
          <Route path="/konflikthaandtering" element={<ConflictManagement />} />
          <Route path="/konflikthandtering/" element={<ConflictManagement />} />
          <Route path="/konflikthandtering" element={<ConflictManagement />} />

          <Route path="/foredrag-og-workshops/" element={<Workshops />} />
          <Route path="/foredrag-og-workshops" element={<Workshops />} />
          <Route path="/workshops/" element={<Workshops />} />
          <Route path="/workshops" element={<Workshops />} />

          <Route path="/coaching-for-ledere-og-virksomheder/" element={<Coaching />} />
          <Route path="/coaching-for-ledere-og-virksomheder" element={<Coaching />} />
          <Route path="/coaching/" element={<Coaching />} />
          <Route path="/coaching" element={<Coaching />} />

          <Route path="/erhvervspsykoterapeut/" element={<CorporatePsychotherapist />} />
          <Route path="/erhvervspsykoterapeut" element={<CorporatePsychotherapist />} />

          {/* Privatlivspolitik */}
          <Route path="/privatlivspolitik/" element={<PrivacyPolicy />} />
          <Route path="/privatlivspolitik" element={<PrivacyPolicy />} />

          {/* Artikler & Blog */}
          <Route path="/artikler/" element={<ArticlesIndex />} />
          <Route path="/artikler" element={<ArticlesIndex />} />
          <Route path="/artikler/:slug/" element={<ArticleDetail />} />
          <Route path="/artikler/:slug" element={<ArticleDetail />} />
          <Route path="/blog/" element={<ArticlesIndex />} />
          <Route path="/blog" element={<ArticlesIndex />} />
          <Route path="/blog/:slug/" element={<ArticleDetail />} />
          <Route path="/blog/:slug" element={<ArticleDetail />} />

          {/* Kontakt */}
          <Route path="/kontakt/" element={<Contact />} />
          <Route path="/kontakt" element={<Contact />} />

          {/* Error pages */}
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Sticky Mobile CTA bar (< 1200px) */}
      <StickyMobileCta />

      {/* Footer */}
      <Footer />
    </div>
  );
}
